import {FC, ReactNode, RefObject, useCallback, useEffect, useState} from 'react';
import {Box, Flex, Popover, Portal} from '@chakra-ui/react';
import {EllipseButton} from 'ui-kit';

export interface IQuickMenuItem {
  id: string;
  node: ReactNode;
}

export interface IQuickMenuProps {
  items: Array<IQuickMenuItem>;
  container?: RefObject<HTMLElement | null>;
}

const QuickDocumentMenuFC: FC<IQuickMenuProps> = ({items, container}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    document.addEventListener('scroll', handleClose, true);
    return () => {
      document.removeEventListener('scroll', handleClose, true);
    };
  }, [handleClose]);

  return (
    <Popover.Root
      open={isOpen}
      closeOnEscape
      closeOnInteractOutside
      positioning={{placement: 'top-end'}}
      onOpenChange={(e) => setIsOpen(e.open)}
    >
      <Popover.Trigger asChild>
        <Box _hover={{cursor: 'pointer'}}>
          <EllipseButton
            isRounded
            icon={'Dots'}
            iconSize={'s24'}
            size={'normal'}
            variant={'dark'}
          />
        </Box>
      </Popover.Trigger>
      <Portal container={container}>
        <Popover.Positioner>
          <Popover.Content w={'fit-content'} bg={'transparent'} boxShadow={'none'}>
            <Popover.Body p={0} mb={'-4px'}>
              <Flex gap={'4px'} flexDirection={'column'} alignItems={'end'}>
                {items.map((item) => (
                  <Box key={item.id} w={'fit-content'}>
                    {item.node}
                  </Box>
                ))}
              </Flex>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export const QuickDocumentMenu = QuickDocumentMenuFC;
